<template>
    <div class="row">
        <div class="col-sm-1">id: {{ item.id }}</div>
        <div
            class="col"
            style="cursor: pointer"
            @click.prevent="downloadItem"
        >{{ item.name }}</div>
        <div class="col-sm-1 text-right">
            <core-icon
                @click.native="deleteItem"
                class="pointer"
                iconName="Delete"
                iconColor="#bdbdbd"
            >
              <icons-close></icons-close>
            </core-icon>
        </div>
    </div>
</template>

<script>
import Media from '@/services/hatsApi/Media'
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    async downloadItem () {
      try {
        let downloadMediaResponse = await Media.downloadMedia(this.item.id)
        if (downloadMediaResponse.data) {
          const file = new Blob(
            [downloadMediaResponse.data],
            { type: downloadMediaResponse.data.type }
          )
          const fileURL = URL.createObjectURL(file)
          window.open(fileURL)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deleteItem () {
      try {
        let deleteMediaResponse = await Media.deleteServiceMedia(this.item.id)
        if (deleteMediaResponse.data.success) {
          this.$emit('deleted', true)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Media.vue